import { Link } from 'react-router-dom';
import Header from './partials/Header';
import '../css/NotFound.css';

export default function NotFound() {
    return (
        <div className="ef-page ef-not-found">
            <Header />
            <main className="ef-not-found__main" id="main-content">
                <div className="ef-not-found__card">
                    <span className="ef-not-found__code" aria-hidden="true">404</span>
                    <p className="ef-not-found__eyebrow">Pagina non trovata</p>
                    <h1>Questa pagina non è disponibile.</h1>
                    <p>Il collegamento potrebbe essere cambiato o la pagina potrebbe non esistere più. Puoi tornare alla home e continuare la tua ricerca.</p>
                    <Link className="ef-not-found__button" to="/">Torna alla home <span aria-hidden="true">→</span></Link>
                </div>
            </main>
        </div>
    );
}
